export enum ETooltipEvent {
    INIT = 'tooltip:init',
}
